import type { ConfirmStep } from '../types/thankYou'

export const confirmSteps: ConfirmStep[] = [
  {
    title: 'Watch for our message',
    body: 'In the next few minutes you\u2019ll get a text and an email from Twenty Mile House with your tour details. Save our number so the message doesn\u2019t get filtered.',
  },
  {
    title: 'Reply to confirm \u2014 this is the step that counts',
    body: 'Just reply to the text with your preferred tour day and time.',
    highlight: 'Your tour is only held once you reply.',
  },
  {
    title: 'Add it to your calendar & get inspired',
    body: 'Once confirmed, add your tour to your calendar, then browse the weddings below to see how couples have made the property their own. Bring your questions \u2014 we\u2019ll walk you through everything.',
  },
]
